module.exports = __webpack_public_path__ + "static/media/brown-bold.671bec60.ttf";